$ = require 'jquery'
_ = require 'underscore'
Backbone = require 'app/scripts/lib/backbone'
{ googleDriveClientId } = require '@trello/config'

class GoogleApi
  @loadedAuth: ->
    # If the script is loaded, gapi should be in the window scope
    # If it isn't, then something went wrong (perhaps it was blocked by an
    # extension or something)
    window.gapi?.load 'auth', =>
      @loaded = true
      @trigger('loaded')
      @authorize(true)

  @authorize: (immediate, next) ->
    # If we have a valid token, use it
    if @validToken()
      return next?(null, @oauthToken.access_token)

    # The immediate flag will try the authorize in the background and will not
    # prompt the user if it fails. This allows us to avoid a popup for users
    # that have already granted access to Trello.
    gapi.auth.authorize
      client_id: googleDriveClientId
      scope: 'https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/drive.file'
      immediate: immediate
    , (result) =>
      if !result || result.error
        @oauthToken = null
        return next?(result?.error ? Error("Failed to request token"))

      @oauthToken = result

      next?(null, @oauthToken.access_token)

  @validToken: ->
    # Token must exist and not have expired
    @oauthToken?.access_token && \
      (Date.now() / 1000) < parseInt(@oauthToken.expires_at)

_.extend GoogleApi, Backbone.Events

module.exports = GoogleApi